import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { LogOut, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import Avatar from "../atoms/Avatar";

const AvatarMenu: React.FC = () => {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const handleProfile = () => navigate("/profile");

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          className="flex items-center gap-2 px-2 py-1 rounded-full hover:bg-gray-200 focus-visible:ring-2"
          aria-haspopup="menu"
        >
          {user ? (
            <Avatar src={user.photoURL || undefined} name={user.displayName || user.email || "User"} />
          ) : (
            <User size={20} />
          )}
          <span className="hidden md:inline">
            {user?.displayName || user?.email || "Profile"}
          </span>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="bg-white rounded shadow border border-gray-200 text-gray-700 w-48 sm:w-56"
        >
          <DropdownMenu.Item
            className="px-4 py-2 hover:bg-primary/10 cursor-pointer"
            onSelect={handleProfile}
          >
            View Profile
          </DropdownMenu.Item>
          <DropdownMenu.Separator className="my-1 border-t" />
          <DropdownMenu.Item
            onSelect={logout}
            className="px-4 py-2 hover:bg-error-100 text-error-700 cursor-pointer flex gap-2 items-center"
          >
            <LogOut size={20} /> Logout
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default AvatarMenu;
